import React, { useCallback, useState } from 'react'

export type AgTechToggleProps = {
    isToggled?: boolean,
    caption: string,
    onToggled: (value: boolean) => void,
    setting?: {
        width?: number,
        disabled?: boolean
    }
}

const AgTechToggle = (props: AgTechToggleProps) => {
    let [isChecked, setIsChecked] = useState(props.isToggled ?? false);

    const handleToggleChanged = useCallback(() => {
        setIsChecked(checked => {
            props.onToggled(!checked);
            return !checked;
        });
        
    }, []);

    const toggleWidth = props.setting?.width ?? 48;
    const toggleHeight = toggleWidth / 2;
    const toggleIndicatorDiameter = toggleHeight  - 6;
    const togglePadding = 2;
    const toggleMove = toggleIndicatorDiameter + togglePadding + 4;

    const toggleColors = isChecked ? 'bg-highlight border-highlight' : 'bg-light-gray';
    const toggleFocusColors = 'focus-within:border-highlight focus-within:bg-highlight-300'

    return (
        <div className='row-based container'>
            <h1 className="text-xs text-detail font-semibold font-no-wrap mb-2">{props.caption}</h1>
            <div className="column-based-vertically-centered container" style={{ height: toggleHeight, width: toggleWidth }}>
                <label className="m-0 relative inline-block" style={{ height: toggleHeight, width: toggleWidth }}>
                    <div className={`clickable border absolute-child relative color-changing ${toggleFocusColors} ${toggleColors} div`} style={{ borderRadius: toggleHeight }}>
                        <input type="checkbox" className='ml-2 opacity-0' checked={isChecked} onChange={handleToggleChanged} />
                        <div
                            className='rounded-circle bg-white bordered absolute'
                            style={{
                                height: toggleIndicatorDiameter,
                                width: toggleIndicatorDiameter,
                                top: 2,
                                left: togglePadding,
                                transition: '.4s',
                                transform: isChecked ? `translateX(${toggleMove}px)` : undefined
                            }}
                        />
                    </div>
                </label>
            </div>
        </div>
    )
}

export default AgTechToggle